<template>
  <div class="goodsDetails container1" :class="{mask:showLoading}" v-loading="showLoading" element-loading-background="#ffffff">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item v-for="(v,i) in dataBreadcrumb" :key="i">
        <router-link :to="{path:v.path,query:v.query}" target="_blank">
          <span>{{v.name}}</span>
        </router-link>
      </el-breadcrumb-item>
      <span>{{goodsInfo.goodsNo}}</span>
    </el-breadcrumb>

    <div class="header">
      <div class="media">
        <div class="main_img">
          <video ref="video" v-show="showVideo" :src="videoSrc" controls="controls" controlslist="nodownload" @ended="pauseVideo(localImgIndex)">
            您的浏览器不支持 video 标签。
          </video>
          <vue-photo-zoom-pro v-show="!showVideo" :url="effectImg?effectImg:''" :out-zoomer="true" :out-zoomer-style="{zIndex:333}"></vue-photo-zoom-pro>
          <div class="play_icon" v-show="videoSrc && !showVideo" @click="playVideo">
            <i class="el-icon-video-play"></i>
          </div>
        </div>
        <div class="swiper_box">
          <Swiper ref="mySwiper" :options="swiperOption" @transitionStart="onTransitionStart">
            <swiper-slide class="swiper-slide" v-for="(v,i) in effectBanner" :key="i">
              <img :class="{active:localImgIndex==i}" v-lazy="v.filePath" alt="图片加载失败" @mouseover="pauseVideo(i)" />
            </swiper-slide>
          </Swiper>
          <div class="swiper-button-next" v-if="effectBanner.length>5" :class="{'swiper-button-disabled':activeIndex+4==effectBanner.length-1}" @click="nextSlide">
            <i class="myicon iconfont icon-xiayiye"></i>
          </div>
          <div class="swiper-button-prev" v-if="effectBanner.length>5" :class="{'swiper-button-disabled':activeIndex==0}" @click="prevSlide">
            <i class="myicon iconfont icon-xiayiye-copy"></i>
          </div>
        </div>
      </div>

      <div class="goods">
        <div class="brand">
          <div class="style" v-if="goodsInfo.styleName">{{goodsInfo.styleName}}</div>
          <div class="list" v-if="$store.getters.userTypeA">
            <router-link :to="{path:'/brandHall/brandCategory',query:{brandSerNos:goodsInfo.brandSerNo}}" target="_blank">进入品牌系列></router-link>
          </div>
        </div>
        <h3 class="name" v-if="goodsInfo.name && currentMix.mixName">
          <i class="boutique">{{goodsInfo.isCanUseForWhole===0?"精品":"拎包"}}</i>
          {{goodsInfo.name+' '+currentMix.mixName}}
        </h3>
        <p class="kw">{{goodsInfo.title}}</p>
        <div class="price">
          <div>
            <span style="width:100px;display:inline-block;">市场参考价</span>
            <span class="money" style="font-size:16px;font-weight:400;text-decoration:line-through"><span class="text">￥</span>{{currentMix.salePrice | priceValue}}</span>
          </div>

          <div>
            <span style="width:100px;display:inline-block;" :class="{com_link:isSeePrice}" @click="onSeePrice">多比价</span>
            <span class="money" v-if="$cookies.isKey('ACCESS_TOKEN')"><span class="text">￥</span>{{currentMix.clientSalePrice | priceValue}}</span>
            <span class="money cur_pointer" v-else @click="$refs.diaLogin.elVisible = true;">登录查看多比价</span>
            <see-original-price ref="seePrice"></see-original-price>
          </div>
        </div>
        <div class="sale" v-if="currentMix.saleCount!=null || currentMix.viewCount!=null">
          <div class="item" v-if="currentMix.saleCount!=null">
            已售 <span class="num">{{currentMix.saleCount}}</span> 件
          </div>
          <div class="item" v-if="currentMix.viewCount!=null">
            人气 浏览 <span class="num">{{currentMix.viewCount}}</span>
          </div>
        </div>
        <el-form class="com_el_form" ref="form" :model="goodsInfo" label-width="68px" label-position="left">

          <el-form-item class="attr_scroll" v-for="(attr,attrKey,attrIndex) in attrInfo" :key="attrIndex" :label="attr.name">
            <div class="attr_type" v-show="attr.specialType == 0">
              <el-tooltip :open-delay="500" :visible-arrow="false" effect="light" :offset="-10" :content="item.name" placement="top-end" v-for="(item,index) in attr.contentList" :key="index">
                <button v-if="!item.isDisabled" :disabled="item.isDisabled" type="button" class="group" :class="attr.currentId == item.id?'active':' '" @click="changeAttr(item,attr)">{{item.name}}</button>
              </el-tooltip>
            </div>
            <div class="attr_type" v-show="attr.specialType == 1">
              <el-popover popper-class="img_popover" trigger="hover" placement="top" :tabindex="index" v-for="(item,index) in attr.contentList" :key="index">
                <p class="hover_img"><img :src="item.filePath" alt /></p>
                <button v-if="!item.isDisabled" slot="reference" :disabled="item.isDisabled" type="button" class="color_img" :class="attr.currentId == item.id?'active':' '" @click="changeAttr(item,attr)">
                  <img v-lazy="item.filePath" alt />
                </button>
              </el-popover>
            </div>
            <div class="attr_type" v-show="attr.specialType == 2">
              <el-tooltip :open-delay="500" :visible-arrow="false" effect="light" :offset="-30" :content="item.name" placement="top-end" v-for="(item,index) in attr.contentList" :key="index">
                <button v-if="!item.isDisabled" :disabled="item.isDisabled" type="button" class="color_img" :class="attr.currentId == item.id?'active':' '" @click="changeAttr(item,attr)">
                  <div class="bc_box" :style="{backgroundColor: item.colorRGB}"></div>
                </button>
              </el-tooltip>
            </div>
          </el-form-item>

          <el-form-item label="运费">
            <span>{{goodsInfo.startPlace}}</span>
            <span style="padding:0 16px">至</span>
            <City @getEndPlace="getEndPlace"></City>
            <span class="money" v-show="freightFee>=0">￥{{freightFee | priceValue}}</span>
          </el-form-item>

          <el-form-item label="服务" class="service_item">
            <div :class="{service:true,active:isShowService}" @click="changeService">
              <span>送货入户并安装</span>
              <span class="money" v-show="isShowService"> ￥{{serviceFee | priceValue}}</span>
              <i class="el-icon-check check" v-show="isShowService"></i>
            </div>
          </el-form-item>

          <el-form-item label="购买数量">
            <el-input-number v-model="goodsCount" controls-position="right" :min="1" :max="999" :precision="0" size="small" @change="onChangeCount"></el-input-number>
          </el-form-item>

          <el-form-item label="交货期" v-if="goodsInfo.sendGoodsDay">
            <div>{{goodsInfo.sendGoodsDay}}{{goodsInfo.sendGoodsDayMax?'—'+goodsInfo.sendGoodsDayMax+'天':'天'}}</div>
          </el-form-item>

          <el-form-item label="品质">
            <el-rate v-model="rate" :disabled="true" :colors="colors"></el-rate>
          </el-form-item>

          <el-form-item label="送货速度">
            <el-rate v-model="rate" :disabled="true" :colors="colors"></el-rate>
          </el-form-item>
        </el-form>
        <div class="add" v-if="currentMix.status == 8">
          <el-button class="item" :disabled="btnDis" @click="buyShop">直接购买</el-button>
          <el-button class="item" type="primary" :disabled="btnDis" :loading="loading" @click="addShoppingCart(currentMix.id,goodsCount)">
            加入购物车
          </el-button>
        </div>
        <div class="share">
          <i class="myicon iconfont icon-bqxin" :class="isCollectionId?'activeI':''" @click="followGoods(currentMix.id)"></i>
          <span class="cur_pointer" @click="followGoods(currentMix.id)">收藏商品</span>
          <!-- <span style="margin-right:10px">分享到</span>
            <img v-lazy="require('@/assets/img/sc-icon-2.png')" alt />
            <img v-lazy="require('@/assets/img/sc-icon-3.png')" alt />
            <img v-lazy="require('@/assets/img/sc-icon-4.png')" alt />-->
        </div>
        <!-- 已下架 -->
        <div class="un_load_goods" v-if="currentMix.status && currentMix.status != 8">已下架</div>
      </div>

      <div class="same_goods">
        <same-goods :seriesLike="seriesLike" @noLogin="showDiaLogin"></same-goods>
      </div>
    </div>

    <recommended v-if="recomMix.length" :recomMix="recomMix" :currentMix="currentMix" :effectImg="effectImg" @noLogin="showDiaLogin"></recommended>

    <!-- 解决底部闪烁问题 -->
    <div class="footer" v-if="!showLoading">
      <div class="like">
        <same-goods title="相似风格" :stylesLike="stylesLike" @noLogin="showDiaLogin"></same-goods>
      </div>
      <div class="itr_box">
        <goods-itr :goodsInfo="goodsInfo" :currentMix="currentMix" :classList="classList"></goods-itr>
      </div>
    </div>

    <dialog-login ref="diaLogin" @updateLogin="updateLogin"></dialog-login>
    <back-top></back-top>
  </div>
</template>

<script>
import index from "./js/goodsDetails";
export default {
  ...index,
};
</script>

<style lang="less" scoped>
.goodsDetails {
  padding-top: 20px;
  padding-bottom: 100px;
  color: #333333;
  line-height: 1;
  .el-breadcrumb {
    font-size: 12px;
    .el-breadcrumb__item {
      a {
        color: #333333;
        font-weight: 400;
        &:hover {
          color: @themeColor;
        }
      }
    }
  }
  .header {
    display: flex;
    .media {
      width: 498px;
      height: 612px;
      box-sizing: border-box;
      .main_img {
        width: 100%;
        height: 498px;
        box-sizing: border-box;
        border: 1px solid #e4e4e4;
        position: relative;
        /deep/ .photo-zoom-pro {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          .container {
            width: auto;
            height: auto;
            .origin-img {
              width: auto;
              height: auto;
              max-width: 496px;
              max-height: 496px;
            }
          }
        }
        video {
          width: 100%;
          height: 100%;
        }
        .play_icon {
          position: absolute;
          bottom: 10px;
          left: 10px;
          font-size: 60px;
          color: #404040;
          z-index: 3;
          cursor: pointer;
        }
      }
      .swiper_box {
        margin-top: 24px;
        width: 100%;
        height: 90px;
        position: relative;
        .swiper-container {
          height: 100%;
          img {
            border: 2px solid #ffffff;
            box-sizing: border-box;
          }
          .active {
            border: 2px solid @themeColor;
            box-sizing: border-box;
          }
        }
        .swiper-button-prev {
          left: 0;
        }
        .swiper-button-next {
          right: 0;
        }
        .swiper-button-next,
        .swiper-button-prev {
          top: 50%;
          margin-top: -11px;
          width: 22px;
          height: 22px;
          background-image: none;
          .myicon {
            font-size: 22px;
          }
        }
        .swiper-button-disabled {
          pointer-events: auto; //打开鼠标样式
          cursor: not-allowed;
          .myicon {
            color: #b3b3b3;
          }
        }
      }
    }
    .goods {
      // width: calc(100% - 498px - 176px);//516
      width: 516px;
      padding: 0 32px;
      box-sizing: border-box;
      font-size: 12px;
      .brand {
        display: flex;
        line-height: 30px;
        .style {
          background-color: @themeColor;
          padding: 0 15px;
          color: #ffffff;
        }
        .list {
          margin-left: 26px;
          color: #384e5b;
          a {
            color: #384e5b;
          }
        }
      }
      .name {
        margin-top: 4px;
        font-size: 16px;
        font-weight: bold;
        line-height: 30px;
        .boutique {
          display: inline-block;
          width: 32px;
          height: 18px;
          line-height: 18px;
          text-align: center;
          background: #d8a67d;
          color: #fff;
          font-size: 12px;
          margin-right: 8px;
          position: relative;
          top: -1px;
        }
      }
      .kw {
        margin-top: 10px;
        color: @themeColor;
      }
      .price {
        margin-top: 14px;
        width: 100%;
        height: 74px;
        padding: 4px 0;
        box-sizing: border-box;
        padding-left: 20px;
        background: #f7f6f5;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        .text {
          font-weight: 400;
          font-size: 16px;
          color: #d00000;
        }
        .money {
          font-size: 24px;
          font-weight: bold;
          color: #d00000;
        }
      }
      .sale {
        margin-top: 20px;
        display: flex;
        .item {
          width: 194px;
          text-align: center;
          &:first-child {
            border-right: 2px solid #696969;
          }
          .num {
            color: #d00000;
          }
        }
      }
      .com_el_form {
        margin-top: 28px;
      }
      .add {
        margin-top: 20px;
        .item {
          width: 132px;
          height: 36px;
          padding: 0;
          border-radius: 0;
          &:first-child {
            border-color: @themeColor;
            color: @themeColor;
          }
        }
        .el-button + .el-button {
          margin-left: 26px;
        }
      }
      .share {
        display: flex;
        align-items: center;
        margin-top: 20px;
        color: #696969;
        .myicon {
          font-size: 12px;
          color: #696969;
          margin-right: 6px;
          cursor: pointer;
          vertical-align: middle;
        }

        .activeI {
          color: #ff0000;
        }
      }
      .un_load_goods {
        line-height: 48px;
        color: red;
        font-size: 24px;
        font-weight: bold;
      }
    }
    .same_goods {
      width: 176px;
      box-sizing: border-box;
    }
  }
  .footer {
    display: flex;
    margin-top: 86px;
    .like {
      width: 244px;
      margin-right: 46px;
    }
    .itr_box {
      width: calc(100% - 244px - 46px);
    }
  }
}
.mask {
  position: relative;
  &::after {
    display: block;
    content: "";
    width: 100%;
    height: 100%;
    background: #ffffff;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
  }
}
/deep/ .el-loading-spinner {
  top: 300px;
}
</style>